import { ButtonBase } from '@mui/material';
import { Link } from 'react-router-dom';

import JustpointLogo from '../assets/images/justpoint_monogram_black.svg';

const LogoButton = () => {
    return (
        <ButtonBase disableRipple component={Link} to="/">
            <img height="40" width="40" alt="Justpoint Logo" src={JustpointLogo} />
        </ButtonBase>
    );
};

export default LogoButton;
